import { Platform } from 'react-native';
import { AdyenCheckoutChannel } from 'types/generatedSchemaTypes';

// Platform.OS -> the BFF's AdyenCheckoutChannel enum. web -> 'WEB'; the two
// native platforms map to their uppercased OS name. The default is a defensive
// fallback that never fires in practice (RN only reports ios/android/web here).
// Shared by card-add initiation (persisted server-side as wallet consent
// evidence) and the later Checkout discovery/payment calls, so both report the
// same surface.
export const checkoutChannelForPlatform = (): AdyenCheckoutChannel => {
  switch (Platform.OS) {
    case 'ios':
      return 'IOS';
    case 'android':
      return 'ANDROID';
    default:
      return 'WEB';
  }
};
